import { BaseService } from './base-service';
export class ReportsService {
    static getMagazine(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return BaseService.getPaginated(`reports/report-magazine?filter=${qs}`, pageNumber);
    }
    static exportExcelMagazine(filter) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        BaseService.downloadFile(`reports/export-excel/report-magazine?filter=${qs}`, 'magazine.xlsx', null);
    }
    static exportExcelInsoluti(filter) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        BaseService.downloadFile(`reports/export-excel/report-insoluti?filter=${qs}`, 'insoluti.xlsx', null);
    }
    static exportExcelProjects(filter) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        BaseService.downloadFile(`reports/export-excel/report-projects?filter=${qs}`, 'progetti.xlsx', null);
    }
    static exportExcelProjectActions(filter) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        BaseService.downloadFile(`reports/export-excel/report-project-actions?filter=${qs}`, 'progetti_azioni.xlsx', null);
    }
}
